import { useApolloClient, useMutation } from "@apollo/client";
import Archive from "@mui/icons-material/Archive";
import { useAlerts } from "components/Alerts/AlertProvider";
import { ConfirmDialog } from "components/ConfirmDialog";

import { ARCHIVE_PIPELINE_RUN_MUTATION } from "./api";

/** Confirms archiving a run, shared by the runs grid and the run results page. */
export function ArchivePipelineRunDialog({
  pipelineId,
  refetchQueries,
  onClose,
}: {
  pipelineId: string;
  /** Refetched on success and on refusal, which usually means the page is stale. */
  refetchQueries: string[];
  onClose: () => void;
}) {
  const alerts = useAlerts();
  const client = useApolloClient();
  const [archive, { loading }] = useMutation(ARCHIVE_PIPELINE_RUN_MUTATION, { refetchQueries });

  const handleConfirm = async () => {
    try {
      await archive({ variables: { pipelineId } });
      alerts.success("Run archived");
    } catch (err) {
      alerts.error(err instanceof Error ? err.message : "Failed to archive run");
      await client.refetchQueries({ include: refetchQueries });
    }
    onClose();
  };

  return (
    <ConfirmDialog
      open
      onClose={onClose}
      onConfirm={handleConfirm}
      loading={loading}
      header="Archive Pipeline Run"
      info="Archiving hides this run from Pipeline Runs and Vendor Data, and it can't be ingested. This can't be undone."
      confirmText="Archive"
      confirmStartIcon={<Archive />}
    />
  );
}
